import * as JSZip from 'jszip'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/from'
import { Exportacao } from '../../../pkw-data/collect/exportacao.model'
import { ConfiguracaoExportacao } from './configuracao-exportacao'
import { ErroExportacao } from './error-exportacao'

export class ExportacaoFinalizada {
    arquivo: File
    origem: Exportacao[]
    erros: ErroExportacao[]

    constructor(
        arquivo: File,
        exportacoesDeOrigem: Exportacao[],
        erros: ErroExportacao[]
    ) {
        this.arquivo = arquivo
        this.origem = exportacoesDeOrigem
        this.erros = erros
    }

    static fromExportacoesGeradas(
        exportacoes: Exportacao[],
        config: ConfiguracaoExportacao,
        erros: ErroExportacao[],
        formato: string
    ) {
        if (exportacoes.length === 1) {
            const exportacao = exportacoes[0]
            const arquivo = exportacao.possuiDados()
                ? exportacao.criarArquivo(formato)
                : undefined

            return Observable.of(new ExportacaoFinalizada(arquivo, exportacoes, erros))
        } else {
            return this.concatenarEmZip(exportacoes, config, erros, formato)
        }
    }

    private static concatenarEmZip(
        exportacoes: Exportacao[],
        config: ConfiguracaoExportacao,
        erros: ErroExportacao[],
        formato: string
    ) {
        const exportacoesComDados = exportacoes.filter(exp => exp.possuiDados())

        if (exportacoesComDados.length === 0) {
            return Observable.of(new ExportacaoFinalizada(undefined, exportacoes, erros))
        }

        const zip = new JSZip()
        const fileName = `Cartao_${
            config.modelo.empresaQueVendeComCartoes.empresa.idExterno
        }.zip`

        exportacoesComDados.forEach(exportacao => {
            const arquivo = exportacao.criarArquivo(formato)
            zip.file(arquivo.name, arquivo)
        })

        return Observable.from(
            zip.generateAsync({
                type: 'blob',
                compression: 'DEFLATE',
                compressionOptions: {
                    level: 5
                }
            })
        ).map(blob => {
            const options = {
                type: 'application/zip'
            }
            let arquivo: File

            try {
                arquivo = new File([blob], fileName, options)
            } catch (e) {
                // fallback para o PHD
                if (e.message === 'Illegal constructor') {
                    const file: any = blob

                    file.lastModified = new Date().getTime()
                    file.name = fileName
                    file.fileName = fileName

                    arquivo = file as File
                }
            }

            return new ExportacaoFinalizada(arquivo, exportacoes, erros)
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/exportacao-movimento/shared/exportacao-finalizada.ts